import brandsModel from "../models/brands.model";
import collectionsModel from "../models/collections.model";
import ecomcategoriesModel from "../models/ecomcategories.model";
import productsModel from "../models/products.model";
import tagsModel from "../models/tags.Model";
import vendorModel from "../models/vendor.model";
const filterCategory = async (string, callback) => {

    if (string == "" || string.length < 3) {
        return null;
    }

    const data = await ecomcategoriesModel.list({ title: string });
    const tempData = data?.data
    await tempData?.map((item) => {
        item.value = item.id
        item.label = item.title;
        return item;
    })
    callback(tempData);
}

const filterCollection = async (string, callback) => {

    if (string == "" || string.length < 3) {
        return null;
    }

    const data = await collectionsModel.list({ title: string });
    const tempData = data?.data
    await tempData?.map((item) => {
        item.value = item.id
        item.label = item.title;
        return item;
    })
    callback(tempData);
}

const filterSeller = async (string, callback) => {

    if (string == "" || string.length < 3) {
        return null;
    }

    const data = await vendorModel.list({ name: string });
    const tempData = data?.data
    await tempData?.map((item) => {
        item.value = item.id
        item.label = item.name;
        return item;
    })
    callback(tempData);
}

const filterBrands = async (string, callback) => {

    if (string == "" || string.length < 3) {
        return null;
    }

    const data = await brandsModel.list({ title: string });
    const tempData = data?.data
    await tempData?.map((item) => {
        item.value = item.id
        item.label = item.title;
        return item;
    })
    callback(tempData);
}

const filterProducts = async (string, callback) => {

    if (string == "" || string.length < 3) {
        return null;
    }

    const data = await productsModel.list({ title: string });
    const tempData = data?.data
    await tempData?.map((item) => {
        item.value = item.id
         item.label = item.sku ? `${item.sku} - ${item.title}` : item.title;
        return item;
    })
    callback(tempData);
}

const filterTags = async (string, callback) => {

    if (string == "" || string.length < 3) {
        return null;
    }

    const data = await tagsModel.list({ name: string });
    const tempData = data?.data
    await tempData?.map((item) => {
        item.value = item.id
        item.label = item.name;
        return item;
    })
    callback(tempData);
}


export default {
    filterCategory, filterCollection, filterSeller,filterBrands,filterTags,filterProducts
};